// Dummy data untuk User
export const dummyUserData = [
  {
    id: 1,
    fullName: "Ahmad Fauzi Rahman",
    position: "Manager",
    directorate: "Direktorat Teknologi Informasi",
    phoneNumber: "+6281234567890",
    email: "ahmad.fauzi@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Pusat",
    updatedAt: "2024-01-15T10:30:00Z",
    createdAt: "2024-01-15T10:30:00Z"
  },
  {
    id: 2,
    fullName: "Siti Nurhaliza Putri",
    position: "Supervisor",
    directorate: "Direktorat Koperasi",
    phoneNumber: "+6282234567891",
    email: "siti.nurhaliza@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Regional Jakarta",
    updatedAt: "2024-01-14T14:20:00Z",
    createdAt: "2024-01-14T14:20:00Z"
  },
  {
    id: 3,
    fullName: "Budi Santoso Widodo",
    position: "Staff",
    directorate: "Direktorat Teknologi Informasi",
    phoneNumber: "+6283234567892",
    email: "budi.santoso@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Pusat",
    updatedAt: "2024-01-13T09:15:00Z",
    createdAt: "2024-01-13T09:15:00Z"
  },
  {
    id: 4,
    fullName: "Dewi Lestari Sari",
    position: "Manager",
    directorate: "Direktorat Koperasi",
    phoneNumber: "+6284234567893",
    email: "dewi.lestari@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Regional Surabaya",
    updatedAt: "2024-01-12T16:45:00Z",
    createdAt: "2024-01-12T16:45:00Z"
  },
  {
    id: 5,
    fullName: "Eko Prasetyo Nugroho",
    position: "Supervisor",
    directorate: "Direktorat Teknologi Informasi",
    phoneNumber: "+6285234567894",
    email: "eko.prasetyo@kemenp2mi.go.id",
    isActive: false,
    updatedBy: "Admin Pusat",
    updatedAt: "2024-01-11T11:30:00Z",
    createdAt: "2024-01-11T11:30:00Z"
  },
  {
    id: 6,
    fullName: "Fitri Handayani Putri",
    position: "Staff",
    directorate: "Direktorat Koperasi",
    phoneNumber: "+6286234567895",
    email: "fitri.handayani@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Regional Bandung",
    updatedAt: "2024-01-10T13:20:00Z",
    createdAt: "2024-01-10T13:20:00Z"
  },
  {
    id: 7,
    fullName: "Gunawan Wijaya Kusuma",
    position: "Manager",
    directorate: "Direktorat Teknologi Informasi",
    phoneNumber: "+6287234567896",
    email: "gunawan.wijaya@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Pusat",
    updatedAt: "2024-01-09T08:45:00Z",
    createdAt: "2024-01-09T08:45:00Z"
  },
  {
    id: 8,
    fullName: "Hendra Kusuma Wardana",
    position: "Supervisor",
    directorate: "Direktorat Koperasi",
    phoneNumber: "+6288234567897",
    email: "hendra.kusuma@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Regional Medan",
    updatedAt: "2024-01-08T15:10:00Z",
    createdAt: "2024-01-08T15:10:00Z"
  },
  {
    id: 9,
    fullName: "Indah Permata Sari",
    position: "Staff",
    directorate: "Direktorat Teknologi Informasi",
    phoneNumber: "+6289234567898",
    email: "indah.permata@kemenp2mi.go.id",
    isActive: false,
    updatedBy: "Admin Pusat",
    updatedAt: "2024-01-07T10:25:00Z",
    createdAt: "2024-01-07T10:25:00Z"
  },
  {
    id: 10,
    fullName: "Joko Widodo Santoso",
    position: "Manager",
    directorate: "Direktorat Koperasi",
    phoneNumber: "+6281234567899",
    email: "joko.widodo@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Regional Makassar",
    updatedAt: "2024-01-06T14:40:00Z",
    createdAt: "2024-01-06T14:40:00Z"
  },
  {
    id: 11,
    fullName: "Kartika Sari Dewi",
    position: "Supervisor",
    directorate: "Direktorat Teknologi Informasi",
    phoneNumber: "+6282234567800",
    email: "kartika.sari@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Pusat",
    updatedAt: "2024-01-05T09:55:00Z",
    createdAt: "2024-01-05T09:55:00Z"
  },
  {
    id: 12,
    fullName: "Linda Wijayanti Putri",
    position: "Staff",
    directorate: "Direktorat Koperasi",
    phoneNumber: "+6283234567801",
    email: "linda.wijayanti@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Regional Semarang",
    updatedAt: "2024-01-04T16:15:00Z",
    createdAt: "2024-01-04T16:15:00Z"
  },
  {
    id: 13,
    fullName: "Muhammad Rizki Pratama",
    position: "Manager",
    directorate: "Direktorat Teknologi Informasi",
    phoneNumber: "+6284234567802",
    email: "muhammad.rizki@kemenp2mi.go.id",
    isActive: false,
    updatedBy: "Admin Pusat",
    updatedAt: "2024-01-03T11:30:00Z",
    createdAt: "2024-01-03T11:30:00Z"
  },
  {
    id: 14,
    fullName: "Nurul Hidayah Sari",
    position: "Supervisor",
    directorate: "Direktorat Koperasi",
    phoneNumber: "+6285234567803",
    email: "nurul.hidayah@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Regional Yogyakarta",
    updatedAt: "2024-01-02T13:45:00Z",
    createdAt: "2024-01-02T13:45:00Z"
  },
  {
    id: 15,
    fullName: "Oki Setiawan Nugroho",
    position: "Staff",
    directorate: "Direktorat Teknologi Informasi",
    phoneNumber: "+6286234567804",
    email: "oki.setiawan@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Pusat",
    updatedAt: "2024-01-01T10:20:00Z",
    createdAt: "2024-01-01T10:20:00Z"
  },
  {
    id: 16,
    fullName: "Putri Ayu Lestari",
    position: "Manager",
    directorate: "Direktorat Koperasi",
    phoneNumber: "+6287234567805",
    email: "putri.ayu@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Regional Denpasar",
    updatedAt: "2023-12-31T15:30:00Z",
    createdAt: "2023-12-31T15:30:00Z"
  },
  {
    id: 17,
    fullName: "Qori Maulana Rahman",
    position: "Supervisor",
    directorate: "Direktorat Teknologi Informasi",
    phoneNumber: "+6288234567806",
    email: "qori.maulana@kemenp2mi.go.id",
    isActive: false,
    updatedBy: "Admin Pusat",
    updatedAt: "2023-12-30T09:40:00Z",
    createdAt: "2023-12-30T09:40:00Z"
  },
  {
    id: 18,
    fullName: "Rina Marlina Sari",
    position: "Staff",
    directorate: "Direktorat Koperasi",
    phoneNumber: "+6289234567807",
    email: "rina.marlina@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Regional Solo",
    updatedAt: "2023-12-29T14:55:00Z",
    createdAt: "2023-12-29T14:55:00Z"
  },
  {
    id: 19,
    fullName: "Sandi Pratama Widodo",
    position: "Manager",
    directorate: "Direktorat Teknologi Informasi",
    phoneNumber: "+6281234567808",
    email: "sandi.pratama@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Pusat",
    updatedAt: "2023-12-28T11:10:00Z",
    createdAt: "2023-12-28T11:10:00Z"
  },
  {
    id: 20,
    fullName: "Tina Rahayu Putri",
    position: "Supervisor",
    directorate: "Direktorat Koperasi",
    phoneNumber: "+6282234567809",
    email: "tina.rahayu@kemenp2mi.go.id",
    isActive: true,
    updatedBy: "Admin Regional Palembang",
    updatedAt: "2023-12-27T16:25:00Z",
    createdAt: "2023-12-27T16:25:00Z"
  }
];

// Options untuk dropdown
export const positionOptions = [
  { value: "BP3MI", label: "BP3MI" },
  { value: "Direktur", label: "Direktur" },
  { value: "Verifikator", label: "Verifikator" },
  { value: "Superadmin", label: "Superadmin" },
];

export const directorateOptions = [
  { value: "Direktorat Peningkatan Kapasitas", label: "Direktorat Peningkatan Kapasitas" },
  { value: "Direktorat Vokasi", label: "Direktorat Vokasi" }
];

// Function to simulate API response with pagination and filtering
export const getDummyUserData = (params = {}) => {
  const { limit = 10, page = 1, filter = [] } = params;

  let filteredData = [...dummyUserData];

  // Apply filters
  if (filter && filter.length > 0) {
    filter.forEach(f => {
      if (f.field === 'fullName' && f.value) {
        filteredData = filteredData.filter(item =>
          item.fullName.toLowerCase().includes(f.value.toLowerCase()) ||
          item.email.toLowerCase().includes(f.value.toLowerCase()) ||
          item.position.toLowerCase().includes(f.value.toLowerCase())
        );
      }
    });
  }

  const totalItems = filteredData.length;
  const startIndex = (page - 1) * limit;
  const endIndex = startIndex + limit;
  const items = filteredData.slice(startIndex, endIndex);

  return {
    items,
    totalItems,
    currentPage: page,
    totalPages: Math.ceil(totalItems / limit)
  };
};
